export enum alertType {
  danger = 'danger',
  info = 'info',
  success = 'success',
  warning = 'warning',
}
